module.exports = __webpack_public_path__ + "static/media/Laugo_21.8c34fae3.jpg";